export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'shebei-xuangou',
    name: '设备选购',
    description: '国产手机选购指南，帮你找到最适合自拍的设备',
    icon: 'ri-smartphone-line',
    imageSeq: 'device-selection-guide-01',
  },
  {
    slug: 'goutu-jiqiao',
    name: '构图技巧',
    description: '掌握黄金构图法则，让自拍画面更有故事感',
    icon: 'ri-focus-2-line',
    imageSeq: 'composition-skills-01',
  },
  {
    slug: 'buguang-dengguang',
    name: '布光与灯光',
    description: '善用自然光与人造光，打造完美自拍光影效果',
    icon: 'ri-sun-line',
    imageSeq: 'lighting-guide-01',
  },
  {
    slug: 'houqi-xiutu',
    name: '后期修图',
    description: '手机修图App教程，从调色到精修一步步来',
    icon: 'ri-image-edit-line',
    imageSeq: 'post-editing-01',
  },
  {
    slug: 'paizhe-changjing',
    name: '拍摄场景',
    description: '旅行、美食、夜景等不同场景下的自拍实战指南',
    icon: 'ri-landscape-line',
    imageSeq: 'scene-shooting-01',
  },
  {
    slug: 'zimei-jingyan',
    name: '自媒经验',
    description: '小红书/抖音博主分享的自拍运营与涨粉心得',
    icon: 'ri-share-line',
    imageSeq: 'social-media-experience-01',
  },
];